import {
  PortfolioApiError,
  isPortfolioAccessErrorCode,
  type PortfolioAccessErrorCode,
} from "./portfolio-overview-api.ts";
import type { MessageKey } from "./translations.ts";

export const PORTFOLIO_ACCESS_ERROR_MESSAGES = {
  account_inactive: "access.error.accountInactive",
  mfa_enrollment_required: "access.error.mfaEnrollmentRequired",
  mfa_challenge_required: "access.error.mfaChallengeRequired",
  provider_not_allowed: "access.error.providerNotAllowed",
  profile_not_found: "access.error.profileNotFound",
  unverified_email: "access.error.unverifiedEmail",
  permission_denied: "access.error.permissionDenied",
} as const satisfies Readonly<Record<PortfolioAccessErrorCode, MessageKey>>;

export interface PortfolioFailureState {
  readonly kind: "error";
  readonly sessionExpired: boolean;
  readonly accessError?: PortfolioAccessErrorCode | null;
}

export function portfolioFailureState(error: unknown): PortfolioFailureState {
  const code = error instanceof PortfolioApiError ? error.code : null;
  return {
    kind: "error",
    sessionExpired: code === "session_expired",
    accessError: isPortfolioAccessErrorCode(code) ? code : null,
  };
}

export function portfolioErrorMessageKey(
  error: unknown,
  fallback: MessageKey,
): MessageKey {
  const state = portfolioFailureState(error);
  if (state.sessionExpired) return "session.expired.description";
  return state.accessError
    ? PORTFOLIO_ACCESS_ERROR_MESSAGES[state.accessError]
    : fallback;
}
